// extracted by mini-css-extract-plugin
export default {"base":"LinkButton_base__ZiA0d","iconContainer":"LinkButton_iconContainer__6daY+","active":"LinkButton_active__4I4O+","danger":"LinkButton_danger__MgIBc"};